module.exports = __webpack_public_path__ + "static/media/HNIT.47e0a086.png";